var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-wrapper",class:_vm.computedClasses,style:(_vm.computedStyles)},[(_vm.imagePath)?_c('img',{staticClass:"avatar-image",attrs:{"src":_vm.imagePath}}):(!_vm.imagePath && _vm.name || _vm.text)?_c('div',{staticClass:"avatar-initials"},[_vm._v(" "+_vm._s(_vm.text || _vm.initials)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }